import { formatJalaliFromIsoDate, formatQuantityFraction } from '@clinic/money-date';
import { fa } from '../../../shared/i18n/fa';

/** `2027-05-31` → `۱۴۰۶/۰۳/۱۰`; the Gregorian date stays visible beside it where it matters. */
export function jalaliExpiry(date: string | null): string {
  return date ? formatJalaliFromIsoDate(date) : fa.inventory.noExpiry;
}

export function qty(value: string, unit?: string): string {
  return unit ? `${formatQuantityFraction(value)} ${unit}` : formatQuantityFraction(value);
}
